export default "__VITE_ASSET__5111b6bc__"